/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Broadcast_Desc9Inputs */

const en_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions and updates via approved templates, segmented and scheduled, without bans.`)
};

const ar_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عروض وتحديثات عبر قوالب معتمدة، مقسمة ومجدولة، دون حظر.`)
};

const bn_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনুমোদিত টেমপ্লেটে প্রোমো আর আপডেট, ভাগ করে সময় দিয়ে, ব্যান ছাড়াই।`)
};

const de_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen und Neuigkeiten über freigegebene Vorlagen, segmentiert und geplant, ohne Sperren.`)
};

const es_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promociones y novedades con plantillas aprobadas, segmentadas y programadas, sin bloqueos.`)
};

const fr_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions et nouveautés via des templates approuvés, segmentés et planifiés, sans bannissements.`)
};

const pt_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções e novidades com templates aprovados, segmentados e agendados, sem bloqueios.`)
};

const zh_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用官方模板做促销和通知，分组分时发送，账号不被封。`)
};

const tr_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onaylı şablonlarla promosyon ve duyurular, bölümlü ve zamanlı, banlanmadan.`)
};

const ru_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Акции и новости по одобренным шаблонам, сегментированно и по расписанию, без банов.`)
};

const pl_svc_messaging_bots_broadcast_desc9 = /** @type {(inputs: Svc_Messaging_Bots_Broadcast_Desc9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promocje i nowości przez zatwierdzone templatki, segmentowane i planowane, bez banów.`)
};

/**
* | output |
* | --- |
* | "Promotions and updates via approved templates, segmented and scheduled, without bans." |
*
* @param {Svc_Messaging_Bots_Broadcast_Desc9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_broadcast_desc9 = /** @type {((inputs?: Svc_Messaging_Bots_Broadcast_Desc9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Broadcast_Desc9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "de") return de_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "es") return es_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_broadcast_desc9(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_broadcast_desc9(inputs)
	return en_svc_messaging_bots_broadcast_desc9(inputs)
});
export { svc_messaging_bots_broadcast_desc9 as "svc_messaging-bots_BROADCAST_desc" }